export const rentalRoutes = {
	rentalIndex: '/rentals',
	rentalAdd: '/rentals/add',
	rentalHistory: (id?: string) => `/rentals/${id ?? ':id'}/history`,
	rentalEdit: (id?: string) => `/rentals/${id ?? ':id'}`
} as const
